import {
  ImageStyle,
  LoaderStyle,
  LoadingText,
  SpinnerStyle,
  ImageContainer
} from './Loader.styles';

import { Loader as Assets } from '@CS/assets';
import LottieAnimation from '@CS/components/LottieAnimation';
import Spinner from '@CS/assets/Vector/spinner.svg?component';

export type LoaderProps = {
  overlay?: boolean;
  opacity?: number;
  lottie?: boolean;
  image?: boolean;
  color?: string;
  speed?: number;
  width?: number;
};

export const Loader = ({
  color = 'white',
  lottie = true,
  image = false,
  width = 242,
  speed = 2.5
}: LoaderProps) => {
  const loader = lottie ? (
    <ImageStyle>
      <ImageContainer width={width}>
        <LottieAnimation animationData={Assets.Lottie} />
        <LoadingText>Laden...</LoadingText>
      </ImageContainer>
    </ImageStyle>
  ) : image ? (
    <ImageStyle>
      <ImageContainer width={width}>
        <img src={Assets.Gif} />
      </ImageContainer>
    </ImageStyle>
  ) : (
    <SpinnerStyle color={color} speed={speed} width={width}>
      <Spinner />
    </SpinnerStyle>
  );

  return <LoaderStyle>{loader}</LoaderStyle>;
};
